import fromPairs from 'lodash/fromPairs';
import { objectOf } from 'prop-types';
import React from 'react';
import { Alert, Badge } from 'reactstrap';

import CommentBody from '../../comments/Comments/CommentBody';
import CommentHeader from '../../comments/Comments/CommentHeader';
import {
  campaignShape,
  changeRequestShape,
  commentShape,
  userShape,
} from '../../prop-types';
import EmptyComponent from '../../utils/empty-component';
import storedUserInfo from '../../utils/session-data/user-info';
import { changeStatuses } from '../constants';
import OPTIONS from '../options';
import Approvals from './Approvals';
import Withdraw from './Withdraw.container';

const TYPES = fromPairs(OPTIONS.map(option => [option.value, option.Comment]));
const BADGE_COLORS = {
  Pending: 'primary',
  Granted: 'success',
  'Waiting For Client Signature': 'info',
  Denied: 'danger',
  Withdrawn: 'secondary',
  'Rejected By Client': 'secondary',
};
function ChangeRequestComment({ comment, changeRequest, usersById, campaign }) {
  const Component = TYPES[changeRequest.type] || EmptyComponent;

  const sender = usersById[comment.senderId];

  const currentUser = storedUserInfo.get();
  const currentUserId = currentUser.id;
  const currentUserRoles = currentUser.roles;

  const showApprovals = changeRequest.status === changeStatuses.pending;

  const showWithdrawButton =
    (changeRequest.ownerId === currentUserId ||
      campaign?.ownerId === currentUserId) &&
    (changeRequest.status === changeStatuses.pending ||
      changeRequest.status === changeStatuses.waitingForClientSignature);

  return (
    <Alert
      color="secondary"
      className="mb-0 px-2 py-1 text-break qa-change-request-comment"
    >
      <CommentHeader model={comment} sender={sender} withReplyToggle={false}>
        <Badge
          className="ml-1 float-right"
          color={BADGE_COLORS[changeRequest.status]}
        >
          {changeRequest.status}
        </Badge>
      </CommentHeader>
      <h2 className="h5 my-3">{changeRequest.type}</h2>
      <Component comment={comment} changeRequest={changeRequest} />
      <CommentBody model={comment} />
      {showApprovals && (
        <div className="mt-2">
          <Approvals
            approvals={changeRequest.approvals}
            currentUserRoles={currentUserRoles}
            approvalRoles={changeRequest.approvalRoles}
            usersById={usersById}
            changeRequestId={changeRequest.id}
            campaignId={changeRequest.campaignId}
          />
        </div>
      )}
      {showWithdrawButton && (
        <div className="mt-2">
          <Withdraw
            changeRequestId={changeRequest.id}
            campaignId={changeRequest.campaignId}
          />
        </div>
      )}
    </Alert>
  );
}

ChangeRequestComment.propTypes = {
  comment: commentShape.isRequired,
  changeRequest: changeRequestShape.isRequired,
  usersById: objectOf(userShape.isRequired).isRequired,
  campaign: campaignShape.isRequired,
};

export default ChangeRequestComment;
